<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row justify="center" class="mx-10">
      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2 color="primary">{{ $i18n.t("General Reports") }}</h2>
          </div>
          <!-- <router-link :to="'/reports/driver'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-account-group</v-icon>
              {{ $i18n.t("Driver Report") }}
            </h4>
          </router-link> -->
          <router-link :to="'/reports/vehicle/revenue'" v-if="$ha(270)" class="my-5">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-car</v-icon>
              {{ $i18n.t("Vehicle Report") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/feedback'" v-if="$ha(270)" class="my-5">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5"
                >mdi-comment-quote-outline</v-icon
              >
              {{ $i18n.t("Feedback") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/incidents'" v-if="$ha(270)" class="my-5">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-car-emergency</v-icon>
              {{ $i18n.t("Incidents") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40" v-if="$ha(270)">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Revenue Reports") }}</h2>
          </div>
          <!-- <router-link :to="'/reports/revenue/general'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-finance</v-icon>
              {{ $i18n.t("General Revenue Report") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/revenue/user'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-chart-bar</v-icon>
              {{ $i18n.t("User Revenue Report") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/revenue/supplier'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-chart-line</v-icon>
              {{ $i18n.t("Supplier Report") }}
            </h4>
          </router-link> -->
          <router-link :to="'/reports/trip/revenue'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-chart-line</v-icon>
              {{ $i18n.t("Trip Revenue Report") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Log Reports") }}</h2>
          </div>
          <router-link :to="'/reports/accesslog'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5"
                >mdi-file-chart-outline</v-icon
              >
              {{ $i18n.t("Access Logs") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/smslog'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-message-text</v-icon>
              {{ $i18n.t("SMS Logs") }}
            </h4>
          </router-link>
          <router-link :to="'/reports/soslog'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5">mdi-lifebuoy</v-icon>
              {{ $i18n.t("SOS Logs") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <!-- <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Travel Reports") }}</h2>
          </div>
          <router-link :to="'/report/tripreport'" v-if="$ha(270)">
            <h4 class="my-5">
              <v-icon color="primary" class="me-5"
                >mdi-car-traction-control</v-icon
              >
              {{ $i18n.t("Trip Report") }}
            </h4>
          </router-link>
        </div>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SettingsMenu",

  data() {
    return {};
  },

  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
